import { render } from "./StudentIncome.vue?vue&type=template&id=bb7ceba2"
import script from "./StudentIncome.vue?vue&type=script&lang=js"
export * from "./StudentIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__